import { createModuleContext } from "./moduleStorage.js";
const modules = new Map();
/**
 * Register an {@link ArtisModule} under a `type` name, so Panes can host it by that
 * name. Calls the module's `init` once. Idempotent: a second call with the same `type`
 * is a no-op (the first registration wins). Done at startup today.
 *
 * @param type - the name a Pane references to load this module (e.g. `"chart"`, `"scratchpad"`).
 * @param module - the module definition. For React, wrap a component with `reactArtisModule`.
 *
 * @example
 * ```ts
 * registerArtisModule("scratchpad", reactArtisModule(Scratchpad));
 * ```
 */
export const registerArtisModule = (type, module) => {
    if (modules.has(type))
        return;
    module.init?.(createModuleContext(type));
    modules.set(type, module);
};
/** Look up a registered {@link ArtisModule} by `type`, or `undefined` if none is registered. */
export const getArtisModule = (type) => modules.get(type);
/** Every registered module `type` name. */
export const listArtisModuleTypes = () => [...modules.keys()];
//# sourceMappingURL=moduleRegistry.js.map